<h1 matDialogTitle>
  <ng-container *ngIf="!data?.testbed?.id">New Testbed</ng-container>
  <ng-container *ngIf="data?.testbed?.id">Edit Testbed</ng-container>
</h1>
<mat-dialog-content>

  <aw-testbed-form 
    [fromContract]="creatingFromContract"
    [company]="data.company"
    [creatingFromContract]="creatingFromContract"
    [embeddedLayout]="creatingFromContract"
    (testbedEmitter)="returnTestbed($event)"
    [testbed]="data.testbed"
    (saved)="dialogRef.close(creatingFromContract ? returnThisInDialogClose : true)"
    (canceled)="dialogRef.close(false)">
</aw-testbed-form>

</mat-dialog-content>